import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AddressInputComponent } from '@principle-theorem/ng-principle-shared';
import {
  IsoDateSelectorComponent,
  NgCommonModule,
  TypedFormControl,
} from '@principle-theorem/ng-shared';
import {
  ACC_ETHNICITY_MAP,
  AccGender,
  IAddressMetadata,
} from '@principle-theorem/principle-core/interfaces';
import { filterUndefined, toOptions } from '@principle-theorem/shared';
import { AccPatientFormGroup } from '../../form-groups/acc-patient.formgroup';

@Component({
  selector: 'pr-acc-patient-form',
  imports: [
    NgCommonModule,
    MatInputModule,
    MatSelectModule,
    AddressInputComponent,
    MatDividerModule,
    IsoDateSelectorComponent,
  ],
  templateUrl: './acc-patient-form.component.html',
  styleUrls: ['./acc-patient-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccPatientFormComponent {
  form = input.required<AccPatientFormGroup>();
  disabled = input<boolean>(false);
  addressCtrl = new TypedFormControl<IAddressMetadata>({ address: '' });

  genderOptions = toOptions(AccGender);
  ethnicityOptions = toOptions(ACC_ETHNICITY_MAP);

  constructor() {
    this.addressCtrl.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        this.form().address.convertAddressComponents(value.components)
      );

    toObservable(this.disabled)
      .pipe(takeUntilDestroyed())
      .subscribe((disabled) =>
        disabled
          ? this.addressCtrl.disable({ emitEvent: false })
          : this.addressCtrl.enable({ emitEvent: false })
      );
  }
}
